/**
 * Created by Christof Sander on 21.12.2016.
 */

module.exports = {
	config: {
		active: false,
		maxNrOfElements: 5,
		scrollMode: true
	},

	events: {
		choose: {
			type: 'click',
			selector: 'ul li',
			action: function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.close();
				var target = event.originalEvent ? event.originalEvent.target : event.target;
				event.data.component.choose(target.dataset.value);
			}
		},
		open: {
			type: 'focusin',
			selector: 'input',
			action: function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.open();
			}
		},
		close: {
			type: 'focusout',
			selector: 'input',
			action: function (event) {
				// prevent focusout event from preventing the click event on the uls' li
				window.setTimeout(function(component){
					if(component.config.active) component.close();
				}, 100, event.data.component);
			}
		},
		select: {
			type: 'keydown',
			action: function(event){
				if(event.key === 'Escape'){
					event.data.component.close();
				}
				else {
					var validKeyFound = true;

					// arrow down
					var $activeElement;
					if(event.key === 'ArrowDown'){
						$activeElement = event.data.component.$.find('ul > li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = event.data.component.$.find('ul > li.active:not(.disabled)').first();
						}
						else {
							do { $activeElement = $activeElement.next(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = event.data.component.$.find('ul > li.active:not(.disabled)').first();
						}
					}
					else if(event.key === 'ArrowUp'){
						$activeElement = event.data.component.$.find('ul > li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = event.data.component.$.find('ul > li.active:not(.disabled)').last();
						}
						else {
							do { $activeElement = $activeElement.prev(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = event.data.component.$.find('ul > li.active:not(.disabled)').last();
						}
					}
					else {
						validKeyFound = false;
					}

					if(validKeyFound){
						event.preventDefault();
						event.stopImmediatePropagation();

						$activeElement.addClass('selected');
						event.data.component.choose($activeElement.data('value'));
					}
				}
			}
		},
		filter: {
			type: 'keyup',
			selector: 'input',
			action: function(event){
				switch(event.key){
					case 'ArrowUp':
					case 'ArrowDown':
					case 'Escape':
					case 'Tab':
						break;

					default:
						var target = event.originalEvent ? event.originalEvent.target : event.target;
						event.data.component.filter(target.value);
						break;
				}
			}
		}
	},

	methods: {
		open: function(){
			this.$.addClass('active');
			this.config.active = true;
		},
		close: function(){
			this.$.removeClass('active');
			this.config.active = false;
		},
		choose: function(value){
			if(this.$valueField.length > 0){
				this.$valueField.val(value);
				this.model.value = value;
				this.$valueField.change();
			}
		},
		filter: function(filterValue){
			var regExp = new RegExp(filterValue, 'i');
			var $element, value;
			var nrOfActiveElements = 0;
			var self = this;
			this.$.find('ul > li').each(function(index){
				$element    = $(this);
				value       = $element.text();

				if(nrOfActiveElements >= self.config.maxNrOfElements){
					$element.addClass('disabled').removeClass('selected');
				}
				else {
					$element.removeClass('disabled');
				}

				if(value.match(regExp)){
					$element.addClass('active');
					nrOfActiveElements++;
				}
				else {
					$element.removeClass('active selected');
				}
			});

			if(nrOfActiveElements == 0){
				this.close();
			}
			else if(!this.config.active){
				this.open();
			}

			if(nrOfActiveElements <= this.config.maxNrOfElements){
				this.$.find('.end').hide();
			}
			else {
				this.$.find('.end').show();
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(!this.$valueField || this.$valueField.length <= 0){
				this.$valueField = $element.find('input');
			}

			// init filter
			var value = this.$valueField.val();
			if(value != ''){
				this.filter(value);
				this.close();
			}
		}
	}
};
